export default {"src":"/_next/static/media/left-arrow-white.9ff895f4.svg","height":17,"width":10};